import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import "./styles.css";

function Contact() {
    const form = useRef(); // Use a ref to target the actual form element
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phoneNumber: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const sendEmail = (e) => {
        e.preventDefault();

        // Replace these with your actual IDs from EmailJS dashboard
        const serviceID = 'service_68x6ifi';
        const templateID = 'template_v8cp8eb';
        const publicKey = 'EjywYoQHeY369dIAO';

        emailjs.sendForm(serviceID, templateID, form.current, publicKey)
            .then((result) => {
                console.log(result.text);
                alert("Message sent successfully!");
                setFormData({ fullName: '', email: '', phoneNumber: '', subject: '', message: '' });
            }, (error) => {
                console.log(error.text);
                alert("Failed to send message. Please try again.");
            });
    };

    return (
        <section className="contact" id="contact">
            <h2 className="heading">Contact <span>Me</span></h2>

            {/* Added the 'ref' here so EmailJS can read the form fields */}
            <form ref={form} onSubmit={sendEmail}>
                <div className="input-group">
                    <div className="input-box">
                        <input type="text" name="fullName" placeholder="Full Name" value={formData.fullName} onChange={handleChange} required />
                        <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
                    </div>
                    <div className="input-box">
                        <input type="number" name="phoneNumber" placeholder="Phone Number" value={formData.phoneNumber} onChange={handleChange} />
                        <input type="text" name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange} />
                    </div>
                </div>
                <div className="input-group-2">
                    <textarea name="message" cols="30" rows="10" placeholder="Your Message" value={formData.message} onChange={handleChange} required></textarea>
                    <input className="btn" type="submit" value="Send Message" />
                </div>
            </form>
        </section>
    );
}

export default Contact;